import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import BaseScreen from './containers/BaseScreen';
import rootSaga from './sagas';
import createStore from './store';

const { runSaga, store } = createStore();
runSaga(rootSaga);

export default (): JSX.Element => (
  <Provider store={store}>
    <Router>
      <BaseScreen />
    </Router>
  </Provider>
);
